/* @flow */
/* eslint-disable prettier */

import Products from './Products';
import Stores from './Stores';
import type { StoreType, StoreID } from './Stores';
import type { ProductType, ProductID } from './Products';
import { pluck } from '../utils';

type MapType = {
  center: [number, number],
  zoom: number,
  geojsonUrl: string,
};

type CityType = {
  name: string,
  subtitle: string,
  description: string,
  state: string,
  cities: [string],
  products: { [id: ProductID]: ProductType },
  stores: { [id: StoreID]: StoreType },
  map: MapType,
  cardImage: string,
  cardImage2x: string,
  backgroundImage: string,
  backgroundImage2x: string,
};

const CITIES: { [id: string]: CityType } = {
  // minneapolis: {
  //   name: 'Minneapolis',
  //   subtitle: 'Downtown, St. Paul, Maple Grove, & more',
  //   description:
  //     'Get the best movers from Downtown, St. Paul, Maple Grove and all over the greater Minneapolis area to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
  //   state: 'Virginia',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [39.9798, -75.1659],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/minneapolis.json'),
  //   },
  //   cardImage: require('../assets/images/cities/minneapolis/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/minneapolis/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/minneapolis/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/minneapolis/background_2x.jpg'),
  // },
  'new-haven': {
    name: 'New Haven',
    subtitle: 'Downtown, Middlesex, Hartford, & more',
    description:
      'Get the best movers from Downtown, Middlesex, Hartford and all over the greater New Haven area to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Virginia',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.9798, -75.1659],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/new-haven.json'),
    },
    cardImage: require('../assets/images/cities/new-haven/card.jpg'),
    cardImage2x: require('../assets/images/cities/new-haven/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/new-haven/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/new-haven/background_2x.jpg'),
  },
  // austin: {
  //   name: 'Austin',
  //   subtitle: 'Downtown, Round Rock, Georgetown, & more',
  //   description:
  //     'Get the best movers from Downtown Austin, Round Rock, Georgetown, & more and all over the greater Austin area to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
  //   state: 'Virginia',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [39.9798, -75.1659],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/austin.json'),
  //   },
  //   cardImage: require('../assets/images/cities/austin/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/austin/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/austin/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/austin/background_2x.jpg'),
  // },
  houston: {
    name: 'Houston',
    subtitle: 'Downtown, Spring, Sugar Land, & more',
    description:
      'Get the best movers from Downtown Houston, Spring, Sugar Land, and all over the greater Houston area to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Virginia',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.9798, -75.1659],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/houston.json'),
    },
    cardImage: require('../assets/images/cities/houston/card.jpg'),
    cardImage2x: require('../assets/images/cities/houston/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/houston/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/houston/background_2x.jpg'),
  },
  // 'virginia-beach': {
  //   name: 'Virginia Beach',
  //   subtitle: 'Newport News, Norfolk, Chesapeake, & more',
  //   description:
  //     'Get the best movers from Hampton, Norfolk, Chesapeake and all over Virginia Beach to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
  //   state: 'Virginia',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [39.9798, -75.1659],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/virginia-beach.json'),
  //   },
  //   cardImage: require('../assets/images/cities/virginia-beach/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/virginia-beach/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/virginia-beach/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/virginia-beach/background_2x.jpg'),
  // },
  // 'las-vegas': {
  //   name: 'Las Vegas',
  //   subtitle: 'Henderson, Paradise, Spring Valley & more',
  //   description:
  //     'Get the best movers from Henderson, Paradise, Spring Valley and all over Las Vegas to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
  //   state: 'Nevada',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [39.9798, -75.1659],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/las-vegas.json'),
  //   },
  //   cardImage: require('../assets/images/cities/las-vegas/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/las-vegas/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/las-vegas/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/las-vegas/background_2x.jpg'),
  // },
  boston: {
    name: 'Boston',
    subtitle: 'Newton, Brookline, North End, Quincy & more',
    description:
      'Get the best movers from Newton, Brookline, North End, Quincy and all over Boston to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Massachusetts',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.9798, -75.1659],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/boston.json'),
    },
    cardImage: require('../assets/images/cities/boston/card.jpg'),
    cardImage2x: require('../assets/images/cities/boston/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/boston/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/boston/background_2x.jpg'),
  },
  atlanta: {
    name: 'Atlanta',
    subtitle: 'Brookhaven, Downtown, College Park & more',
    description:
      'Get the best movers from Brookhaven, Downtown, College Park and all over Atlanta to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Georgia',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.9798, -75.1659],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/atlanta.json'),
    },
    cardImage: require('../assets/images/cities/atlanta/card.jpg'),
    cardImage2x: require('../assets/images/cities/atlanta/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/atlanta/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/atlanta/background_2x.jpg'),
  },
  // 'salt-lake-city': {
  //   name: 'Salt Lake City',
  //   subtitle: 'Ogden, Salt Lake, Provo & more',
  //   description:
  //     'Get the best movers from Ogden, Salt Lake, Provo and all over Salt Lake City to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
  //   state: 'Utah',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [39.9798, -75.1659],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/salt-lake-city.json'),
  //   },
  //   cardImage: require('../assets/images/cities/salt-lake-city/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/salt-lake-city/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/salt-lake-city/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/salt-lake-city/background_2x.jpg'),
  // },
  // milwaukee: {
  //   name: 'Milwaukee',
  //   subtitle: "Downtown, Walker's Point, Lower East Side & more",
  //   description:
  //     "Get the best movers from Downtown, Walker's Point, Lower East Side and all over Milwaukee to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.",
  //   state: 'Wisconsin',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [39.9798, -75.1659],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/chicago.json'),
  //   },
  //   cardImage: require('../assets/images/cities/milwaukee/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/milwaukee/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/milwaukee/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/milwaukee/background_2x.jpg'),
  // },
  chicago: {
    name: 'Chicago',
    subtitle: 'Waukegan, Downtown, Orland Park & more',
    description:
      'Get the best movers from Waukegan, Downtown, Orland Park and all over Chicago to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Illinois',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.9798, -75.1659],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/chicago.json'),
    },
    cardImage: require('../assets/images/cities/chicago/card.jpg'),
    cardImage2x: require('../assets/images/cities/chicago/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/chicago/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/chicago/background_2x.jpg'),
  },
  philadelphia: {
    name: 'Philadelphia',
    subtitle: 'Trenton, Center City, Wilmington & more',
    description:
      'Get the best movers from Trenton, Center City, Wilmington and all over Philadelphia to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Pennsylvania',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.9798, -75.1659],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/philadelphia.json'),
    },
    cardImage: require('../assets/images/cities/philadelphia/card.jpg'),
    cardImage2x: require('../assets/images/cities/philadelphia/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/philadelphia/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/philadelphia/background_2x.jpg'),
  },
  'new-york-city': {
    name: 'New York City',
    subtitle: 'Brooklyn, Queens, Manhattan, The Bronx & more',
    description:
      'Get the best movers from Brooklyn, Queens, Manhattan, The Bronx and all over New York to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'New York',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [40.7109374, -73.9975377],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/new-york-city.json'),
    },
    cardImage: require('../assets/images/cities/new-york-city/card.jpg'),
    cardImage2x: require('../assets/images/cities/new-york-city/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/new-york-city/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/new-york-city/background_2x.jpg'),
  },
  'jersey-city': {
    name: 'Jersey City',
    subtitle: 'The Heights, Hilltop, Bergen-Lafayette, Newport & more',
    description:
      'Get the best movers fromThe Heights, Hilltop, Bergen-Lafayette, Newport and all over Jersey City to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    cities: ''.split(','),
    state: 'New Jersey',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [40.7109374, -73.9975377],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/new-york-city.json'),
    },
    cardImage: require('../assets/images/cities/jersey-city/card.jpg'),
    cardImage2x: require('../assets/images/cities/jersey-city/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/jersey-city/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/jersey-city/background_2x.jpg'),
  },
  baltimore: {
    name: 'Baltimore',
    subtitle: 'Towson, Columbia, Downtown & more',
    description:
      'Get the best movers in Towson, Columbia, Downtown and all over Baltimore to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Maryland',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [39.297174, -76.611571],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/baltimore.json'),
    },
    cardImage: require('../assets/images/cities/baltimore/card.jpg'),
    cardImage2x: require('../assets/images/cities/baltimore/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/baltimore/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/baltimore/background_2x.jpg'),
  },
  'washington-dc': {
    name: 'Washington, D.C.',
    subtitle: 'Alexandria, Silver Spring, Downtown & more',
    description:
      'Get the best movers in Alexandria, Silver Spring, Downtown and all over D.C. to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Washington, D.C.',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [38.918626, -77.022824],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/washington-dc.json'),
    },
    cardImage: require('../assets/images/cities/washington-dc/card.jpg'),
    cardImage2x: require('../assets/images/cities/washington-dc/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/washington-dc/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/washington-dc/background_2x.jpg'),
  },
  dallas: {
    name: 'Dallas',
    subtitle: 'Fort Worth, Plano, Downtown Dallas & more',
    description:
      'Get the best movers in Fort Worth, Plano, Downtown and all over Dallas to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Texas',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [32.910325, -96.93826],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/dallas.json'),
    },
    cardImage: require('../assets/images/cities/dallas/card.jpg'),
    cardImage2x: require('../assets/images/cities/dallas/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/dallas/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/dallas/background_2x.jpg'),
  },
  miami: {
    name: 'Miami',
    subtitle: 'Downtown, Fort Lauderdale, Palm Beach & more',
    description:
      'Get the best movers in Downtown, Fort Lauderdale, Sunrise, Palm Beach and all over Miami to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Florida',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [26.129242, -80.212344],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/miami.json'),
    },
    cardImage: require('../assets/images/cities/miami/card.jpg'),
    cardImage2x: require('../assets/images/cities/miami/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/miami/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/miami/background_2x.jpg'),
  },
  phoenix: {
    name: 'Phoenix',
    subtitle: 'Glendale, Downtown, Scottsdale & more',
    description:
      'Get the best movers in Downtown, Glendale, Scottsdale, Mesa and all over Phoenix to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Arizona',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [47.6129432, -122.4821475],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/phoenix.json'),
    },
    cardImage: require('../assets/images/cities/phoenix/card.jpg'),
    cardImage2x: require('../assets/images/cities/phoenix/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/phoenix/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/phoenix/background_2x.jpg'),
  },
  // tucson: {
  //   name: 'Tucson',
  //   subtitle: 'Downtown, Littletown, Catalina Foothills & more',
  //   description:
  //     'Get the best movers in Downtown, Littletown, Catalina Foothills and all over Tucson to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
  //   state: 'Arizona',
  //   products: pluck(['pickup', 'van', 'xl'], Products),
  //   stores: Stores,
  //   map: {
  //     center: [47.6129432, -122.4821475],
  //     zoom: 9,
  //     geojsonUrl: require('../assets/geojson/phoenix.json'),
  //   },
  //   cardImage: require('../assets/images/cities/tucson/card.jpg'),
  //   cardImage2x: require('../assets/images/cities/tucson/card_2x.jpg'),
  //   backgroundImage: require('../assets/images/cities/tucson/background.jpg'),
  //   backgroundImage2x: require('../assets/images/cities/tucson/background_2x.jpg'),
  // },
  portland: {
    name: 'Portland',
    subtitle: 'Vancouver, Portland, Gresham, Tigard, Hillsboro & more',
    description:
      'Get the best movers in Vancouver, Portland, Gresham, Tigard, Hillsboro and all over Portland to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Oregon',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [47.6129432, -122.4821475],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/portland.json'),
    },
    cardImage: require('../assets/images/cities/portland/card.jpg'),
    cardImage2x: require('../assets/images/cities/portland/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/portland/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/portland/background_2x.jpg'),
  },
  denver: {
    name: 'Denver',
    subtitle: 'Denver, Lakewood, Aurora, Englewood, Thornton & more',
    description:
      'Get the best movers in Lakewood, Aurora, Englewood, Thornton and all over Denver to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'Colorado',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [47.6129432, -122.4821475],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/denver.json'),
    },
    cardImage: require('../assets/images/cities/denver/card.jpg'),
    cardImage2x: require('../assets/images/cities/denver/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/denver/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/denver/background_2x.jpg'),
  },
  sacramento: {
    name: 'Sacramento',
    subtitle: 'Sacramento, Roseville, Folsom, Davis, Vacaville & more',
    description:
      'Get the best movers in Roseville, Folsom, Davis, Vacaville and all over Sacramento to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'California',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [47.6129432, -122.4821475],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/sacramento.json'),
    },
    cardImage: require('../assets/images/cities/sacramento/card.jpg'),
    cardImage2x: require('../assets/images/cities/sacramento/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/sacramento/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/sacramento/background_2x.jpg'),
  },
  seattle: {
    name: 'Seattle',
    subtitle: 'Bellevue, Tacoma, Downtown, Lynnwood & more',
    description:
      'Get the best movers in Bellevue, Tacoma, Lynnwood and all over Seattle to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.*',
    disclaimer:
      '*Lugg cannot currently perform household goods moves in Washington State. Lugg is not a licensed household goods carrier, common carrier, or solid waste collection company. The transport of all goods is done by independent contractors, called Luggers.',
    state: 'Washington',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [47.6129432, -122.4821475],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/seattle.json'),
    },
    cardImage: require('../assets/images/cities/seattle/card.jpg'),
    cardImage2x: require('../assets/images/cities/seattle/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/seattle/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/seattle/background_2x.jpg'),
  },
  'san-diego': {
    name: 'San Diego',
    subtitle: 'Chula Vista, Carlsbad, San Marcos & more',
    description:
      'Get the best movers in Chula Vista, Carlsbad, San Marcos and all over San Diego to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'California',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [32.8432845, -117.1386697],
      zoom: 10,
      geojsonUrl: require('../assets/geojson/san-diego.json'),
    },
    cardImage: require('../assets/images/cities/san-diego/card.jpg'),
    cardImage2x: require('../assets/images/cities/san-diego/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/san-diego/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/san-diego/background_2x.jpg'),
  },
  'san-francisco': {
    name: 'San Francisco',
    subtitle: 'Berkeley, San Francisco, Oakland & more',
    description:
      'Get the best movers in San Francisco to deliver your new furniture from your favorite furniture stores, move into your new home with same day movers, donate your old furniture or get your craigslist furniture delivered to you.',
    state: 'California',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [37.6592972, -122.2578367],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/san-francisco.json'),
    },
    cardImage: require('../assets/images/cities/san-francisco/card.jpg'),
    cardImage2x: require('../assets/images/cities/san-francisco/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/san-francisco/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/san-francisco/background_2x.jpg'),
  },
  'silicon-valley': {
    name: 'Silicon Valley',
    subtitle: 'Mountain View, Palo Alto, San Jose & more',
    description:
      'Get the best movers in Palo Alto, Mountain View, San Jose and all over Silicon Valley to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'California',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [37.6592972, -122.2578367],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/san-francisco.json'),
    },
    cardImage: require('../assets/images/cities/silicon-valley/card.jpg'),
    cardImage2x: require('../assets/images/cities/silicon-valley/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/silicon-valley/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/silicon-valley/background_2x.jpg'),
  },
  'los-angeles': {
    name: 'Los Angeles',
    subtitle: 'Long Beach, Santa Monica, Downtown, & more',
    description:
      'Get the best movers in Santa Monica, Hollywood, Beverly Hills, Long beach and all over Los Angeles to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'California',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [33.93534, -118.251772],
      zoom: 10,
      geojsonUrl: require('../assets/geojson/los-angeles.json'),
    },
    cardImage: require('../assets/images/cities/los-angeles/card.jpg'),
    cardImage2x: require('../assets/images/cities/los-angeles/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/los-angeles/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/los-angeles/background_2x.jpg'),
  },
  'orange-county': {
    name: 'Orange County',
    subtitle: 'Newport Beach, Costa Mesa, Irvine & more',
    description:
      'Get the best movers in Newport Beach, Laguna beach, Costa Mesa, Irvine and all over Orange County to deliver your new furniture, move you into your new home, deliver your craigslists purchases and donate your old furniture to goodwill.',
    state: 'California',
    products: pluck(['pickup', 'van', 'xl'], Products),
    stores: Stores,
    map: {
      center: [37.6592972, -122.2578367],
      zoom: 9,
      geojsonUrl: require('../assets/geojson/los-angeles.json'),
    },
    cardImage: require('../assets/images/cities/orange-county/card.jpg'),
    cardImage2x: require('../assets/images/cities/orange-county/card_2x.jpg'),
    backgroundImage: require('../assets/images/cities/orange-county/background.jpg'),
    backgroundImage2x: require('../assets/images/cities/orange-county/background_2x.jpg'),
  },
};

export type CityID = $Keys<typeof CITIES>;
export default Object.keys(CITIES)
  .sort()
  .reduce((memo, key) => {
    memo[key] = CITIES[key];
    return memo;
  }, {});



// WEBPACK FOOTER //
// ./src/data/Cities.js